export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";